export const PROJECT_DETAILS_USR_ACTIVATE = 'PROJECT_DETAILS_USR_ACTIVATE';
export const PROJECT_DETAILS_USR_DEACTIVATE = 'PROJECT_DETAILS_USR_DEACTIVATE';



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/project-details/actions/upload-files.ts